import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { DettaglioErroreVO } from "@app/shared/vo/dettaglio-erroreVO";
import { MessaggioErroreVO } from "@app/shared/vo/messaggio-erroreVO";
import { MotivazioneStore } from "@app/store/motivazione-store";
import { BsModalRef, BsModalService } from "ngx-bootstrap";

@Component({
  selector: "app-modale-conferma-chiudi-fascicolo",
  templateUrl: "./modale-conferma-chiudi-fascicolo.component.html",
})
export class ModaleConfermaChiudiFascicoloComponent
  implements OnInit, OnChanges {
  @Output()
  confermaEmit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild("templateModaleConferma", { static: false })
  public confermaModal: TemplateRef<any>;

  disabilitaPulsante: boolean = false;

  alert = {
    isOpen: false,
    type: "danger",
    testo:
      "Per il fascicolo è necessario aggiornare il dato Collocazione fisica dalla sezione 'Modifica dati fascicolo'",
  };
  public motivo: string = "";
  public erroreMotivazioneTesto: string = "Motivazione obbligatoria";
  public erroreMotivazione: boolean = false;
  public modalRef: BsModalRef;

  private config = {
    class: "modal-dialog modal-info modal-lg",
    animated: true,
  };
  constructor(
    private modalService: BsModalService,
    private motivazioneStore: MotivazioneStore
  ) {}

  ngOnChanges(changes: SimpleChanges): void {}

  ngOnInit() {}

  emitConferma(accepted: boolean) {
    if (accepted == true) {
      this.confermaEmit.emit(accepted);
      this.modalRef.hide();
    } else {
      this.alert.isOpen = true;
      this.disabilitaPulsante = true;
    }
  }

  openModal() {
    console.log(
      "[ModaleConfermaComponent][emitConferma]apertura modale conferma"
    );
    this.alert.isOpen = false;
    this.modalRef = this.modalService.show(this.confermaModal, this.config);
    this.disabilitaPulsante = false;
  }
}
